import * as tslib_1 from "tslib";
import chart from "./chart";
import dataService from "@/services/data";
import selectTimeRange from "../../components/selectTimeRange.vue";
import loader from "@/components/loader.vue";
import time from "@/helpers/time";
import noDataOverlay from "@/components/noDataOverlay.vue";
import { Getter, Mutation } from "vuex-class";
import { Vue, Component, Watch } from "vue-property-decorator";
const dbBackground = "rgba(32, 36, 39, 1)";
const cBarText = "rgba(32, 36, 39, 1)";
const cGreen1 = "rgba(0, 241, 155, 1)";
const cRed1 = "rgba(241, 10, 10, 0.8)";
let widget = class widget extends Vue {
    constructor() {
        super(...arguments);
        // data
        this.loading = false;
        this.activeTab = 0;
        this.noDataAvailable = false;
        this.dayData = [1, 2, 3, 4, 5, 4, 8];
        this.maxData = [1, 2, 3, 4, 5, 4, 8];
        this.lastReq = {};
    }
    watchtimeRange() {
        this.updateData();
    }
    watchprofileIds() {
        this.updateData();
    }
    watchsoundSource() {
        this.updateData();
    }
    get chartData() {
        const dr = Object(this.$t("dayRange"));
        let datasets = [
            {
                borderColor: dbBackground,
                backgroundColor: cGreen1,
                data: this.dayData
            }
        ];
        // if(this.activeTab==1){ // if dose, add max dose values
        //   datasets.push({
        //     // type: 'line',
        //     fill: false,
        //     // pointStyle: 'rect',
        //     borderColor: cRed1,
        //     backgroundColor: cRed1,
        //     data: this.maxData
        //   })
        // }
        return {
            labels: [
                dr.su.s2,
                dr.mo.s2,
                dr.tu.s2,
                dr.we.s2,
                dr.th.s2,
                dr.fr.s2,
                dr.sa.s2
            ],
            datasets
        };
    }
    get options() {
        const inst = this;
        let res = {
            maintainAspectRatio: false,
            tooltips: {
                callbacks: {
                    label: (tooltipItem, data) => {
                        const v = data.datasets[0].data[tooltipItem.index];
                        switch (this.activeTab) {
                            case 0: //dose
                                return `${v} %`;
                            case 1: //soundLevel
                                // const max = data.datasets[1].data[tooltipItem.index];
                                // return `Average: ${v} dB\nMax: ${v+max}`;
                                return `Average: ${v} dB`;
                            case 2: //duration
                                return time.digital(v);
                        }
                    }
                }
            },
            animation: {
                duration: 1,
                onProgress: function () {
                    var chartInstance = this.chart, ctx = chartInstance.ctx;
                    ctx.textAlign = "center";
                    ctx.textBaseline = "bottom";
                    ctx.font = "10 px Lato";
                    this.data.datasets.forEach(function (dataset, i) {
                        var meta = chartInstance.controller.getDatasetMeta(i);
                        let max = 0;
                        meta.data.forEach(function (bar, index) {
                            var v = Math.round(dataset.data[index]);
                            max = v > max ? v : max;
                        });
                        meta.data.forEach(function (bar, index) {
                            var v = dataset.data[index];
                            if (v <= 0)
                                return;
                            let text = "";
                            let h, m;
                            switch (inst.activeTab) {
                                case 0: //dose
                                    text = `${Math.round(v)}%`;
                                    break;
                                case 1: //soundLevel
                                    text = `${Math.round(v)} dB`;
                                    break;
                                case 2: //duration
                                    text = time.digital(v);
                                    break;
                            }
                            if (v < max / 5) {
                                ctx.fillStyle = cGreen1;
                                ctx.fillText(text, bar._model.x, bar._model.y - 10);
                            }
                            else {
                                ctx.fillStyle = cBarText;
                                ctx.fillText(text, bar._model.x, bar._model.y + 20);
                            }
                        });
                    });
                }
            },
            responsive: true,
            legend: {
                display: false
            },
            scales: {
                xAxes: [
                    {
                        stacked: true,
                        barPercentage: 1.0,
                        categoryPercentage: 0.95
                    }
                ],
                yAxes: [
                    {
                        stacked: true,
                        position: "right",
                        ticks: {
                            beginAtZero: true,
                            min: 0
                        }
                    }
                ]
            },
            barPercentage: 100,
            categoryPercentage: 100,
            barThickness: "flex",
            color: "#fff"
        };
        switch (this.activeTab) {
            case 0: //dose
                res.scales.yAxes[0].ticks.callback = (v) => v + " %";
                break;
            case 1: //soundLevel
                // const max = data.datasets[1].data[tooltipItem.index];
                // return `Average: ${v} dB\nMax: ${v+max}`;
                res.scales.yAxes[0].ticks.callback = (v) => v + " dB";
                break;
            case 2: //duration
                res.scales.yAxes[0].ticks.callback = (v) => time.digital(v);
                break;
        }
        res.animation.onComplete = res.animation.onProgress;
        return res;
    }
    async updateData() {
        this.loading = true;
        this.noDataAvailable = false;
        // track last request
        this.lastReq = {};
        const lastReqLocal = this.lastReq;
        // get data
        let data = null;
        try {
            data = await dataService.getDaily({
                tz: this.tzName,
                source: this.soundSource,
                from_millis: this.timeRange.min,
                to_millis: this.timeRange.max
            });
        }
        catch (err) {
            this.setLastErr("Could not load Data: " + err);
            return;
        }
        // only let latest request pass
        if (this.lastReq !== lastReqLocal)
            return;
        data = data.Items.filter((v) => this.profileIds.find((p) => v.profile_id == p));
        if (data.length > 0) {
            let dayCnt = [0, 0, 0, 0, 0, 0, 0];
            let dose = [0, 0, 0, 0, 0, 0, 0];
            let soundLevel = [0, 0, 0, 0, 0, 0, 0];
            let maxLevel = [0, 0, 0, 0, 0, 0, 0];
            let duration = [0, 0, 0, 0, 0, 0, 0];
            for (let v of data) {
                const isAdult = this.profileByID[v.profile_id].isAdult || false;
                let dow = v.dow - 1;
                dose[dow] += isAdult ? v.dose_percentage_p1 : v.dose_percentage_p1;
                soundLevel[dow] += v.dba;
                if (maxLevel[dow] < v.max_dba)
                    maxLevel[dow] = v.max_dba;
                duration[dow] += v.duration_seconds;
                dayCnt[dow]++;
            }
            for (let dow in dayCnt) {
                dose[dow] = Math.round(dose[dow] / dayCnt[dow]);
                soundLevel[dow] = Math.round(soundLevel[dow] / dayCnt[dow]);
                duration[dow] = duration[dow] / 60 / 60;
                // maxLevel[dow] = Math.round(maxLevel[dow]-soundLevel[dow])
            }
            switch (this.activeTab) {
                case 0:
                    this.dayData = dose;
                    break;
                case 1:
                    this.dayData = soundLevel;
                    // this.maxData = maxLevel;
                    break;
                case 2:
                    this.dayData = duration;
                    break;
            }
        }
        else {
            this.dayData = [3, 6, 9, 3, -1, 6, 9];
            this.noDataAvailable = true;
        }
        this.loading = false;
    }
    setTab(tab) {
        this.activeTab = tab;
        this.updateData();
    }
};
tslib_1.__decorate([
    Getter("tzName")
], widget.prototype, "tzName", void 0);
tslib_1.__decorate([
    Getter("config/selectedSoundSource")
], widget.prototype, "soundSource", void 0);
tslib_1.__decorate([
    Getter("config/doseChartsTimeRange")
], widget.prototype, "timeRange", void 0);
tslib_1.__decorate([
    Getter("config/profileIds")
], widget.prototype, "profileIds", void 0);
tslib_1.__decorate([
    Getter("auth/profileByID")
], widget.prototype, "profileByID", void 0);
tslib_1.__decorate([
    Mutation
], widget.prototype, "setLastErr", void 0);
tslib_1.__decorate([
    Watch("timeRange", { deep: true })
], widget.prototype, "watchtimeRange", null);
tslib_1.__decorate([
    Watch("profileIds", { deep: true })
], widget.prototype, "watchprofileIds", null);
tslib_1.__decorate([
    Watch("soundSource", { deep: true })
], widget.prototype, "watchsoundSource", null);
widget = tslib_1.__decorate([
    Component({
        components: {
            loader,
            chart: chart,
            "no-data": noDataOverlay,
            "select-time-range": selectTimeRange
        }
    })
], widget);
export default widget;
